<template>
  <div class="data-container-content">
    <div class="flex flex-row items-center mb-2">
      <span class="font-medium mr-3">Kliendi makse</span>
      <div
        class="flex flex-grow items-center cursor-pointer duration-100 px-2 py-1 justify-center border-offwhite-dark"
        :class="
          paymentInfo.payment_type === 1
            ? 'bg-primary text-white'
            : 'text-grey-dark'
        "
        @click="paymentInfo.payment_type = 1"
      >
        Sularaha
      </div>
      <div
        class="flex flex-grow items-center cursor-pointer duration-100 px-2 py-1 justify-center border-l border-offwhite-dark"
        :class="
          paymentInfo.payment_type === 2
            ? 'bg-primary text-white'
            : 'text-grey-dark'
        "
        @click="paymentInfo.payment_type = 2"
      >
        Kaardimakse
      </div>
    </div>
    <div
      v-if="paymentInfo.payment_type"
      class="flex flex-row items-center mb-2"
    >
      <decimal-input v-model="paymentInfo.payment_amount" :decimal-points="2" />
      <div class="flex mx-3">
        <button
          v-if="!saving"
          :class="
            paymentInfo.payment_type && paymentInfo.payment_amount
              ? 'btn-primary'
              : 'btn-disabled'
          "
          @click="
            paymentInfo.payment_type && paymentInfo.payment_amount
              ? setPaymentInformation()
              : ''
          "
        >
          Kinnita
        </button>
        <saving-loader v-else :saving="saving" />
      </div>
    </div>
  </div>
</template>
<script>
import DecimalInput from "@/components/reusable/DecimalInput.vue";
import SavingLoader from "@/components/reusable/SavingLoader.vue";

export default {
  name: "TaskTimer",
  components: { SavingLoader, DecimalInput },
  data() {
    return {
      paymentInfo: {
        payment_type: null,
        payment_amount: 0,
      },
      saving: false,
    };
  },
  methods: {
    setPaymentInformation() {
      this.saving = true;
      this.$emit("setPaymentInformation", this.paymentInfo);
    },
  },
};
</script>
